<template>
  <div v-if="node.kind === 'CONDITION'" class="ms-condition">
    <p v-if="readonly">{{ sentence(node, cell) }}</p>
    <div v-else class="ms-condition-line">
      <template v-if="cell.window.type === 'ROLLING'">
        <span>最近</span>
        <el-input :value="cell.window.amount" size="small" class="ms-window" :label="metric[0] + '统计时长'" @input="changeWindow('amount', $event)" />
        <el-select :value="cell.window.unit" size="small" class="ms-unit-select" :aria-label="metric[0] + '时间单位'" @change="changeWindow('unit', $event)">
          <el-option v-for="unit in units" :key="unit[0]" :label="unit[1]" :value="unit[0]" />
        </el-select>
        <span>内，</span>
      </template>
      <span v-else-if="cell.window.type === 'LIFETIME'">历史累计，</span>
      <span>{{ scopeText(node) }}</span>
      <strong>{{ metric[0] }}</strong>
      <el-tooltip :content="metric[2]" placement="top" v-if="metric[2]">
        <i class="el-icon-question ms-help" tabindex="0" :aria-label="metric[0] + '说明'" />
      </el-tooltip>
      <span>{{ operators[node.operator] }}</span>
      <el-input :value="cell.value" size="small" class="ms-value" :label="metric[0] + '数值'" @input="changeValue('value', $event)" />
      <template v-if="node.operator === 'BETWEEN'">
        <span>至</span>
        <el-input :value="cell.upper" size="small" class="ms-value" :label="metric[0] + '上限'" @input="changeValue('upper', $event)" />
      </template>
      <span>{{ metric[1] }}</span>
    </div>
  </div>
  <div v-else class="ms-group">
    <div class="ms-rule-name">{{ node.ruleName }}</div>
    <div class="ms-branches">
      <div v-for="(child, index) in node.children" :key="child.id" class="ms-branch">
        <span v-if="index" class="ms-logic" :class="{ 'is-or': node.logic === 'OR' }">{{ node.logic === 'OR' ? '或' : '且' }}</span>
        <SnapshotTree :node="child" :values="values" :readonly="readonly" @change="$emit('change', $event)" />
      </div>
    </div>
  </div>
</template>

<script>
import { UNITS, OPERATORS, metricOf, sentence, scopeText } from './model'

export default {
  name: 'SnapshotTree',
  props: {
    node: { type: Object, required: true },
    values: { type: Object, default: () => ({}) },
    readonly: { type: Boolean, default: true },
  },
  data: () => ({ units: UNITS, operators: OPERATORS }),
  computed: {
    cell() { return this.values[this.node.id] || this.node.defaults },
    metric() { return metricOf(this.node) },
  },
  methods: {
    sentence, scopeText,
    changeValue(key, value) { this.$emit('change', { id: this.node.id, cell: { ...this.cell, [key]: value } }) },
    changeWindow(key, value) { this.changeValue('window', { ...this.cell.window, [key]: value }) },
  },
}
</script>

<style lang="less" scoped>
.ms-group { display: flex; align-items: center; width: max-content; min-width: 100%; }
.ms-rule-name { width: 140px; flex: 0 0 140px; padding: 10px 12px; box-sizing: border-box; border: 1px solid #b9cde2; border-radius: 3px; background: #f4f8fc; color: #303133; font-weight: 600; line-height: 20px; overflow-wrap: anywhere; position: relative; }
.ms-rule-name::after { content: ''; position: absolute; width: 22px; height: 1px; background: #b9cde2; right: -23px; top: 50%; }
.ms-branches { padding-left: 44px; }
.ms-branch { padding: 12px 0; position: relative; }
.ms-branch::before { content: ''; position: absolute; width: 22px; top: 50%; left: -22px; border-top: 1px solid #b9cde2; }
.ms-branch::after { content: ''; position: absolute; top: 0; bottom: 0; left: -22px; border-left: 1px solid #b9cde2; }
.ms-branch:first-child::after { top: 50%; }
.ms-branch:last-child::after { bottom: 50%; }
.ms-branch:only-child::after { display: none; }
.ms-logic { position: absolute; top: -10px; left: -33px; z-index: 1; width: 22px; text-align: center; line-height: 20px; background: #fff; color: #168468; font-weight: 600; }
.ms-logic.is-or { color: #b26b18; }
.ms-condition { border: 1px solid #dcdfe6; border-radius: 3px; padding: 12px 14px; background: white; width: max-content; min-width: 340px; }
.ms-condition p { margin: 0; line-height: 24px; max-width: 900px; }
.ms-condition-line { display: flex; align-items: center; gap: 7px; white-space: nowrap; }
.ms-window { width: 66px; }
.ms-value { width: 115px; }
.ms-unit-select { width: 82px; }
.ms-help { color: #909399; cursor: help; }
</style>
